import { action, makeObservable, observable } from 'mobx';

import { storage } from '../shared/consts/storage';

export type GraphicsPerformance = 'ultra' | 'high' | 'medium' | 'low';

export interface IOtherSettingsService {
  widgetHeaderFontSize: number;
  graphicsPerformance: GraphicsPerformance;
  selectWidgetHeaderFontSize(value: number): void;
  selectGraphicsPerformance(value: GraphicsPerformance): void;
  graphicsPerformanceFps: number;
}

export class OtherSettingsStore implements IOtherSettingsService {
  @observable widgetHeaderFontSize: number;
  @observable graphicsPerformance: GraphicsPerformance;

  constructor() {
    this.widgetHeaderFontSize = storage.GET<number>('widgetHeaderFontSize') || 13;
    this.graphicsPerformance = storage.GET<GraphicsPerformance>('graphicsPerformance') || 'medium';

    makeObservable(this);
  }

  private _setWidgetHeaderFontSize(value: number) {
    this.widgetHeaderFontSize = value;
    storage.SET('widgetHeaderFontSize', value);
  }

  private _setGraphicsPerformance(value: GraphicsPerformance) {
    this.graphicsPerformance = value;
    storage.SET('graphicsPerformance', value);
  }

  @action.bound
  selectWidgetHeaderFontSize(value: number) {
    this._setWidgetHeaderFontSize(value);
  }

  @action.bound
  selectGraphicsPerformance(value: GraphicsPerformance) {
    this._setGraphicsPerformance(value);
  }

  get graphicsPerformanceFps() {
    if (this.graphicsPerformance === 'ultra') {
      return 60;
    }
    if (this.graphicsPerformance === 'medium') {
      return 20;
    }
    if (this.graphicsPerformance === 'low') {
      return 10;
    }
    return 30;
  }
}
